import { Field, Formik, Form } from "formik";
import React, { Component } from "react";
import {
  Button,
  Col,
  Container,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { User } from "../../generated";
import { TesterType } from "../../generated/models/TesterType";
import * as Yup from "yup";

export interface State {
  loading: boolean;
}

export interface Props {
  onClosed?: () => void;
  onSubmit?: (user: User) => void;
  close?: () => void;
  user: User;
}

const CustomSelectComponent = (props: any) => (
  <select className="form-control" {...props} />
);

const errorTemplateMessage = (field: string) =>
  `Please fill in ${field} to complete the registration.`;

const SignInSchema = Yup.object().shape({
  telephone: Yup.string()
    .required(errorTemplateMessage("Phone Number"))
    .matches(
      /^[+]?[(]?\d{3}[)]?[-\s.]?\d{3}[-\s.]?\d{4,6}$/im,
      "Phone number is not valid."
    ),

  country: Yup.string().required(errorTemplateMessage("Country")),

  town: Yup.string().required(errorTemplateMessage("Town")),

  testerType: Yup.string().required(errorTemplateMessage("Tester Type")),
});

export class EditUserModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  render() {
    if (!this.props.user) {
      return <></>;
    }

    return (
      <Modal isOpen={!!this.props.user} onClosed={this.props.onClosed}>
        <Formik
          initialValues={this.props.user}
          onSubmit={this.props.onSubmit}
          validationSchema={SignInSchema}
        >
          {({ values, errors, touched }) => (
            <Form>
              <ModalHeader>
                Editing {this.props.user.firstName} {this.props.user.lastName}{" "}
                information
              </ModalHeader>
              <ModalBody>
                <Container>
                  <Row>
                    <Col xs={12}>
                      <FormGroup>
                        <Label htmlFor={`telephone`}>Phone Number</Label>
                        <Input
                          name="telephone"
                          type="text"
                          placeholder="Phone Number"
                          tag={Field}
                          valid={!errors.telephone && touched.telephone}
                          invalid={errors.telephone && touched.telephone}
                        />
                        {errors.telephone && touched.telephone && (
                          <FormFeedback>{errors.telephone}</FormFeedback>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor={`country`}>Country</Label>
                        <Input
                          name="country"
                          type="text"
                          placeholder="Country"
                          tag={Field}
                          valid={!errors.country && touched.country}
                          invalid={errors.country && touched.country}
                        />
                        {errors.country && touched.country && (
                          <FormFeedback>{errors.country}</FormFeedback>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor={`town`}>Town</Label>
                        <Input
                          name="town"
                          type="text"
                          placeholder="Town"
                          tag={Field}
                          valid={!errors.town && touched.town}
                          invalid={errors.town && touched.town}
                        />
                        {errors.town && touched.town && (
                          <FormFeedback>{errors.town}</FormFeedback>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Label>Type</Label>
                        <Field name="testerType" as={CustomSelectComponent}>
                          <option value="" />
                          {Object.values(TesterType).map((tt) => (
                            <option key={tt} value={tt}>
                              {tt.replace(/([a-z](?=[A-Z]))/g, "$1 ")}
                            </option>
                          ))}
                        </Field>
                      </FormGroup>
                    </Col>
                  </Row>
                  {values.testerType === TesterType.EXTERNAL_TESTER && (
                    <Row>
                      <Col xs={12}>
                        <FormGroup>
                          <Label htmlFor={`hourlyRate`}>Hourly Rate</Label>
                          <Input
                            name="hourlyRate"
                            type="number"
                            min="0"
                            tag={Field}
                            placeholder=""
                          />
                          {errors.hourlyRate && touched.hourlyRate && (
                            <FormFeedback>{errors.hourlyRate}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                  {values.testerType === TesterType.EXTERNAL_TESTER && (
                    <Row>
                      <Col xs={12}>
                        <FormGroup>
                          <Label htmlFor={`paymentPerBank`}>
                            Monthly payment per bank
                          </Label>
                          <Input
                            name="paymentPerBank"
                            type="number"
                            min="0"
                            tag={Field}
                            placeholder=""
                          />
                          {errors.paymentPerBank && touched.paymentPerBank && (
                            <FormFeedback>{errors.paymentPerBank}</FormFeedback>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                  {values.testerType === TesterType.EXTERNAL_TESTER && (
                    <Row>
                      <Col xs={12}>
                        <FormGroup>
                          <Label htmlFor={`paymentChannel`}>
                            Payment Channel
                          </Label>
                          <Input
                            name="paymentChannel"
                            type="text"
                            tag={Field}
                            placeholder=""
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                </Container>
              </ModalBody>
              <ModalFooter>
                <Button
                  type={"button"}
                  color="secondary"
                  onClick={this.props.close}
                >
                  Close
                </Button>
                <Button type={"submit"} color="success">
                  Save
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    );
  }
}
